import React from "react";
import { DateTime } from "luxon";
import DayHeaderMobile from "../../DayHeaderMobile";
import { startOfCalendarWeek } from "../../utils";

interface DayHeaderDeps {
  events: any[];
  currentDay: DateTime;
  onDateChange: (date: DateTime) => void;
  firstDay: number;
}

export default function renderDayViewHeader(info: any, deps: DayHeaderDeps) {
  const currentDate = DateTime.fromJSDate(info.date).setZone(
    info.view.dateEnv.timeZone,
  );
  const startOfWeek = startOfCalendarWeek(currentDate, deps.firstDay);

  return (
    <DayHeaderMobile
      startOfWeek={startOfWeek.toJSDate()}
      events={deps.events}
      view={info.view}
      onDateChange={deps.onDateChange}
      selectedDate={deps.currentDay || currentDate}
    />
  );
}
